import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { GET_EXAM_DATA_BEGIN, logError, getExamDataSuccess } from "../actions";
var buildExamDataItem = function(arr) {
    return {
        tries: arr[1] || 0,
        answers: arr[2] || []
    };
};
var buildExamData = function(arr) {
    var _ed = {};
    var i;
    for(i = 0; i < arr.length; i++){
        var exam = arr[i];
        _ed[exam[0]] = buildExamDataItem(exam);
    }
    return _ed;
};
export default function getExamData(action$, state$) {
    return action$.pipe(ofType(GET_EXAM_DATA_BEGIN), switchMap(function(action) {
        var suspendData = state$.value.api ? state$.value.api.getSuspendData() : {};
        if (!state$.value.api) {
            return [
                logError({
                    error: new Error("No LMS API found"),
                    key: "no_api"
                }),
                getExamDataSuccess({
                    examData: {}
                })
            ];
        } else {
            return [
                getExamDataSuccess({
                    examData: suspendData.e ? buildExamData(suspendData.e) : {}
                })
            ];
        }
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "get_exam_data"
        }));
    }));
}
